export default "__VITE_ASSET__BPYfm3Tn__"